<form name="checklist" class="form-group needs-validation" [formGroup]="checklistForm" (ngSubmit)="onSubmit()" novalidate>
    <div class="offset-sm-4 col-sm-4 mb-3">
        <input class="form-control mb-3" style="text-transform: uppercase" aria-describedby="placa" type="text" placeholder="Placa" formControlName="placa" id="placa" mask="AAAAAAA" [class.input-invalid]="invalidPlaca()" required/>
        <input class="form-control" style="text-transform: uppercase" aria-describedby="basic-cpf" type="text" placeholder="CPF" formControlName="cpf" id="cpf" mask="000.000.000-00" [class.input-invalid]="invalidCpf()" required appCpfValidate/>
    </div>
    <div class="col text-center mb-3">
        <button type="submit" class="btn btn-success custom-button" translate="" [disabled]="!validForm()">preCheckout.buttonChecklist</button>
    </div>
    <div [hidden]="!consultaChecklistRealizada" id="divChecklistRetorno">
        <div [hidden]="!consultaChecklistSucesso" id="divChecklistSuccess" class="alert alert-info" role="alert">
            <b>Placa do veículo: </b>{{placa}}<br>
            <b>Data último checklist: </b>{{dataUltimoChecklist | date: 'dd/MM/yyyy'}}<br>
            <b>Dias do último checklist: </b>{{diasPassadosUltimoChecklist}}<br>
            <b>Status: </b>{{statusChecklist}}<br>
        </div>
        <div [hidden]="consultaChecklistSucesso" id="divChecklistError" class="alert alert-danger" role="alert">
             {{mensagem}}
        </div>
    </div>
</form>